import { render, staticRenderFns } from "./promotion.vue?vue&type=template&id=99cb823a&scoped=true"
import script from "./promotion.vue?vue&type=script&lang=ts"
export * from "./promotion.vue?vue&type=script&lang=ts"
import style0 from "./promotion.vue?vue&type=style&index=0&id=99cb823a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cb823a",
  null
  
)

export default component.exports